import { render, staticRenderFns } from "./AnagraficaComponent.vue?vue&type=template&id=40497838&scoped=true"
import script from "./AnagraficaComponent.vue?vue&type=script&lang=js"
export * from "./AnagraficaComponent.vue?vue&type=script&lang=js"
import style0 from "./AnagraficaComponent.vue?vue&type=style&index=0&id=40497838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40497838",
  null
  
)

export default component.exports